<template>
  <div class="hor-header header">
    <div class="container main-container">
      <div class="d-flex align-items-center">
        <!-- Logo -->
        <router-link to="/" class="logo-horizontal">
          <img
              src="/assets/images/brand/logo-dark.png"
              class="header-brand-img light-logo1"
              alt="CNTIPPEE"
          />
        </router-link>

        <!-- Actions -->
        <div class="ms-auto d-flex align-items-center">
          <router-link
              to="/login"
              class="btn btn-outline-primary btn-sm"
          >
            Connexion
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LandingHeader',
  }
</script>
